import React from 'react';

/**
 * AuthLayout
 *
 * Split-screen layout for login and signup pages.
 * Left panel: brand only (logo, name, tagline).
 * Right panel: {children} — the auth form.
 *
 * Responsive: stacks vertically on mobile, side-by-side on md+.
 */
function AuthLayout({ children }) {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* ── Left panel: brand ── */}
      <div
        className="flex flex-col items-center justify-center px-10 py-16 md:w-1/2 order-2 md:order-1"
        style={{
          backgroundColor: '#111',
          borderRight: '1px solid rgba(33,138,255,0.25)',
        }}
      >
        <div className="flex items-center justify-center gap-4">
          <img src="/logo/logo_icon.svg" alt="" aria-hidden="true" className="h-12 w-12" />
          <h1 className="text-4xl font-extrabold tracking-tight leading-none" style={{ color: '#218aff' }}>
            OptionsLeveling
          </h1>
        </div>
        <p className="mt-3 text-xl font-medium text-white/80 text-center">
          Options Analytics for Smarter Trades
        </p>
      </div>

      {/* ── Right panel: auth form ── */}
      <div className="flex items-center justify-center px-6 py-12 md:w-1/2 bg-background order-1 md:order-2">
        {children}
      </div>
    </div>
  );
}

export default AuthLayout;
